module.exports = {
	'#': { pattern: /\d/ },
	'h': { pattern: /[0-9a-fa-f]/, transform: v => v.toLocaleLowerCase() },
	'X': { pattern: /[0-9a-zA-Zа-яА-Я]/ },
	'S': { pattern: /[a-zA-Zа-яА-Я]/ },
	'A': { pattern: /[a-zA-Zа-яА-Я]/, transform: v => v.toLocaleUpperCase() },
	'a': { pattern: /[a-zA-Zа-яА-Я]/, transform: v => v.toLocaleLowerCase() },
	'L': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
	'N': { pattern: /[0-9A-Za-z]/, transform: v => v.toLocaleUpperCase() },
	'!': { escape: true }
}
